export const TABLE_RESULTS_LOADING_INDICATOR_TIMEOUT_MS = 600
